import React from 'react';
import styled from '@emotion/styled';
import { colors } from 'src/theme';

const Container = styled.div<{ $level: number }>(({ $level }) => ({
  display: 'inline-flex',
  borderRadius: 12,
  padding: 4,
  backgroundColor: $level % 2 === 0 ? colors.white : colors.background6,
  margin: '0 auto',
}));

const Option = styled.button<{ $selected: boolean }>(({ $selected }) => ({
  all: 'unset',
  cursor: 'pointer',
  textAlign: 'center',
  minWidth: 50,
  padding: '10px 24px',
  fontSize: 16,
  fontWeight: 700,
  lineHeight: '22px',
  fontFamily: '"Red Hat Display", sans-serif',
  borderRadius: 8,
  transition: 'background-color 0.25s ease, color 0.25s ease',
  color: $selected ? colors.text7 : colors.text1,
  backgroundColor: $selected ? colors.primary : 'transparent',
}));

interface YesNoToggleProps {
  value: boolean | null;
  onChange: (value: boolean) => void;
  className?: string;
  level: number;
}

export const YesNoToggle: React.FC<YesNoToggleProps> = ({ value, onChange, className, level }) => (
  <Container $level={level} className={className}>
    <Option $selected={value === true} onClick={() => onChange(true)}>
      Da
    </Option>
    <Option $selected={value === false} onClick={() => onChange(false)}>
      Ne
    </Option>
  </Container>
);
